// extracted by mini-css-extract-plugin
module.exports = {"root":"WarningComponent_root__2y7Bv","content":"WarningComponent_content__Twk37","text":"WarningComponent_text__3Tcoa"};